import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ComponentModelUploadDataService} from "../component-model-upload-data.service";
import {Subject} from "rxjs";
import {UploadModelTemplateService} from "../../upload-model-template.service";
import {CommonModule} from "@angular/common";
import {
    SelectSearchComponentComponent
} from "../../../../components/select-search-api/single/select-search-component.component";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

@Component({
    selector: 'component-model-upload-select-constant-property',
    templateUrl: './component-model-upload-select-constant-property.component.html',
    imports: [
        CommonModule,
        SelectSearchComponentComponent,
        NgxSkeletonLoaderModule
    ],
    styleUrls: ['../extract-component-options.component.less']
})
export class ComponentModelUploadSelectConstantPropertyComponent implements OnInit, OnDestroy {
    private readonly onDestroy = new Subject<void>();

    @Input() readonly = false;
    @Input() constantPropertyID;
    @Output() constantPropertyIDChange = new EventEmitter<string>();

    /* Select search help method */
    compareValueIds: (a: { id: string }, b: string) => boolean;

    constructor(public dataService: ComponentModelUploadDataService,
                public templateService: UploadModelTemplateService) {
        this.compareValueIds = (a: { id: string }, b: string) => {
            return a.id === b;
        };
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }

    setConstantProperty(value) {
        this.constantPropertyID = value.id;
        this.constantPropertyIDChange.next(value.id);
    }

}
